import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizenVerifyOptNumber} from './citizen-verify-opt-number.model';

export const loadCitizenVerifyOptNumbers = createAction(
  '[CitizenVerifyOptNumber/API] Load CitizenVerifyOptNumbers',
  props<{ citizenVerifyOptNumbers: CitizenVerifyOptNumber[] }>()
);

export const addCitizenVerifyOptNumber = createAction(
  '[CitizenVerifyOptNumber/API] Add CitizenVerifyOptNumber',
  props<{ citizenVerifyOptNumber: CitizenVerifyOptNumber }>()
);

export const upsertCitizenVerifyOptNumber = createAction(
  '[CitizenVerifyOptNumber/API] Upsert CitizenVerifyOptNumber',
  props<{ citizenVerifyOptNumber: CitizenVerifyOptNumber }>()
);

export const addCitizenVerifyOptNumbers = createAction(
  '[CitizenVerifyOptNumber/API] Add CitizenVerifyOptNumbers',
  props<{ citizenVerifyOptNumbers: CitizenVerifyOptNumber[] }>()
);

export const upsertCitizenVerifyOptNumbers = createAction(
  '[CitizenVerifyOptNumber/API] Upsert CitizenVerifyOptNumbers',
  props<{ citizenVerifyOptNumbers: CitizenVerifyOptNumber[] }>()
);

export const updateCitizenVerifyOptNumber = createAction(
  '[CitizenVerifyOptNumber/API] Update CitizenVerifyOptNumber',
  props<{ citizenVerifyOptNumber: Update<CitizenVerifyOptNumber> }>()
);

export const updateCitizenVerifyOptNumbers = createAction(
  '[CitizenVerifyOptNumber/API] Update CitizenVerifyOptNumbers',
  props<{ citizenVerifyOptNumbers: Update<CitizenVerifyOptNumber>[] }>()
);

export const deleteCitizenVerifyOptNumber = createAction(
  '[CitizenVerifyOptNumber/API] Delete CitizenVerifyOptNumber',
  props<{ id: string }>()
);

export const deleteCitizenVerifyOptNumbers = createAction(
  '[CitizenVerifyOptNumber/API] Delete CitizenVerifyOptNumbers',
  props<{ ids: string[] }>()
);

export const clearCitizenVerifyOptNumbers = createAction(
  '[CitizenVerifyOptNumber/API] Clear CitizenVerifyOptNumbers'
);


//CUSTOM
export const citizenVerifyOtpNumber = createAction(
  '[CitizenVerifyOptNumber/API] citizen Verify Otp Number',
  props<{ otp?: string, phoneNumber?: string, userEmail?: string, navTo?: string }>()
);

// export const resendOtpNumber = createAction(
//   '[CitizenVerifyOptNumber/API] citizen Resend Otp Number',
//   props<{ phoneNumber?: string, userEmail?: string }>()
// );
export const resendOtpNumber = createAction(
  '[CitizenVerifyOptNumber/API] citizen Resend Otp Number',
  props<{
    previousValue: string,
    newValue: string,
    inputType: 'EMAIL' | 'PHONE',
  }>()
);
